export default __webpack_public_path__ + "static/media/android_fren_1.207efe80.jpg";